import {useSyncExternalStore, useMemo, useEffect} from 'react';
import {
  LiveAnswersClient,
  LiveAnswersMessage,
} from '@stripe-internal/conversations-client';
import {LiveAnswersStreamer} from '../lib/LiveAnswersStreamer';

/**
 * React hook that polls for LiveAnswers message updates and streams the content
 * character-by-character for a typewriter effect. Includes automatic cleanup.
 */
export function useLiveAnswersStreamer(
  liveAnswersClient: LiveAnswersClient,
  liveAnswersMessage: LiveAnswersMessage,
) {
  const streamerInstance = useMemo(() => {
    return new LiveAnswersStreamer(liveAnswersClient, liveAnswersMessage);
  }, [liveAnswersClient, liveAnswersMessage]);

  const streamer = useMemo(
    () => ({
      startStreaming: () => streamerInstance.startStreaming(),
      stopStreaming: () => streamerInstance.stopStreaming(),
    }),
    [streamerInstance],
  );

  const state = useSyncExternalStore(
    (callback) => streamerInstance.subscribe(callback),
    () => streamerInstance.getState(),
  );

  useEffect(() => {
    return () => {
      streamerInstance.destroy();
    };
  }, [streamerInstance]);

  return {
    ...state,
    streamer,
  };
}
